<div class="p-4 border-1 border-gray-100 border-round-sm shadow-1">
  <div class="flex justify-content-between">
    <div class="flex align-items-center">
      <div class="status-indicator bg-green-500 mr-1" *ngIf="supplierTask.isCurrent"></div>
      <h4 class="m-0 text-lg">{{ supplierTask.vehicleReg }}</h4>
    </div>
    <task-review-status
      [riskStatus]="supplierTask.reviewStatus"
      [reviewDate]="supplierTask.reviewDate"
      [taskId]="supplierTask.taskId"
      (riskStatusChange)="handleRiskStatusChange($event, supplierTask.taskId)"
    ></task-review-status>
  </div>
  <div class="flex flex-wrap gap-2" style="max-width: 75%">
    <span
      ><a
        class="text-blue-500 bold-text"
        target="_blank"
        href="/app/customer-information/{{ supplierTask.customerId }}"
        >{{ supplierTask.customerName }}</a
      >
      <span class="text-gray-600" *ngIf="supplierTask.customerPriority">
        ({{ AMPriorityEnum[supplierTask.customerPriority] }})</span
      >
    </span>
    <span>•</span>
    <span
      ><a
        class="text-blue-500 bold-text"
        target="_blank"
        href="/app/jobscreen/{{ supplierTask.jobId }}"
        >{{ supplierTask.jobNumber }}</a
      >
    </span>
    <span class="text-gray-700">
      (Task {{ supplierTask.currentTaskNumber }} of {{ supplierTask.tasksInJob }})
    </span>
  </div>
  <div class="flex flex-wrap gap-2 my-3 align-items-center">
    <pill
      [backgroundColour]="
        supplierTask.taskStatusDefinitionId === TaskStatusDefinitionEnum.MovementComplete
          ? 'bg-green-200'
          : 'bg-gray-200'
      "
      [textColour]="
        supplierTask.taskStatusDefinitionId === TaskStatusDefinitionEnum.MovementComplete
          ? 'text-green-800'
          : 'text-gray-700'
      "
    >
      <pin-icon></pin-icon>
      <span class="ml-1">{{ supplierTask.taskStatus }}</span>
    </pill>
    <pill textColour="text-gray-700">
      <i class="fa fa-car mr-1"></i>
      <span>{{ supplierTask.movementType }}</span>
    </pill>
  </div>
  <div class="flex flex-wrap align-items-center">
    <span class="bold-text">{{ supplierTask.pickupLocation }}</span>
    <i class="fa fa-arrow-right mx-2 text-gray-600"></i>
    <span class="bold-text">{{ supplierTask.dropoffLocation }}</span>
  </div>
  <div class="ui-g">
    <div class="ui-g-3">
      <div class="text-gray-600">Driver Schedule:</div>
      <div class="text-gray-600">Latest PU-DO:</div>
    </div>
    <div class="ui-g-5">
      <div
        pTooltip="The earliest pickup and latest dropoff times from the driver schedule."
        tooltipPosition="left"
      >
        {{ supplierTask.earliestDriverPickup | dateRange : supplierTask.latestDriverDropoff }}
      </div>
      <div
        pTooltip="The latest PickUp (PU) and latest DropOff (DO) from customer booking windows."
        tooltipPosition="left"
      >
        {{ supplierTask.latestCustomerPickup | dateRange : supplierTask.latestCustomerDropoff }}
      </div>
    </div>
    <div class="ui-g-4 flex justify-content-end">
      <button
        pButton
        type="button"
        label="Edit"
        class="ui-button-secondary"
        pTooltip="Edit Driver Schedule"
        (click)="prepDateTimeSelector()"
      ></button>
    </div>
  </div>

  <div class="my-2">
    <div
      *ngFor="let risk of supplierTask.risks"
      class="p-2 border-round-sm bg-red-50 flex align-items-center my-2"
    >
      <i class="fa fa-exclamation-circle text-red-500 mr-2"></i>
      {{ risk.description }}
    </div>
  </div>
</div>

<p-dialog [(visible)]="showDateTimeSelector" [modal]="true" header="Edit Driver Schedule">
  <app-date-time-selector
    [(pickupDateTime)]="currentEarliestPickup"
    [(dropoffDateTime)]="currentEarliestDropoff"
    [customerEarliestPickup]="supplierTask.earliestCustomerPickup"
    [customerEarliestDropoff]="supplierTask.earliestCustomerDropoff"
    [customerLatestPickup]="supplierTask.latestCustomerPickup"
    [customerLatestDropoff]="supplierTask.latestCustomerDropoff"
  ></app-date-time-selector>

  <p-footer>
    <button
      pButton
      type="button"
      label="Save"
      class="ui-button-primary"
      (click)="saveDriverSchedule()"
    ></button>
  </p-footer>
</p-dialog>
